import { updateNewConversation } from "../collaboration/DbtDocsReducer";
import {
  useDbtDocsCollaborationSelector,
  useDbtDocsCollaborationDispatch,
} from "../collaboration/DbtDocsCollaborationProvider";
import HotspotButton from "../collaboration/HotspotButton";
import { getModelDescriptionElement } from "../collaboration/highlightUtils";
import { ConversationGroup } from "../collaboration/conversations/context/types";

const AddCommentOnModelDescriptionButton = () => {
  const dispatch = useDbtDocsCollaborationDispatch();
  const codeBlockUpdated = useDbtDocsCollaborationSelector(
    state => state.codeblockLoaded
  ) as boolean;
  const descriptionElement = getModelDescriptionElement();

  const handleClick = () => {
    const data = {
      field: "description",
      highlight: descriptionElement?.innerText,
    } as unknown as ConversationGroup["meta"];

    dispatch(updateNewConversation({ meta: data }));
  };

  if (!codeBlockUpdated || !descriptionElement) {
    return null;
  }
  return <HotspotButton target={descriptionElement} onClick={handleClick} />;
};

export default AddCommentOnModelDescriptionButton;
